'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _MultilineText = require('./utils/MultilineText');

var _MultilineText2 = _interopRequireDefault(_MultilineText);

var _color = require('color');

var _color2 = _interopRequireDefault(_color);

var _constants = require('./constants');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
/* injects from baggage-loader */

var isBright = function isBright(color) {
  return (0, _color2.default)(color).light();
};

var StaticNodeView = function (_Component) {
  _inherits(StaticNodeView, _Component);

  function StaticNodeView() {
    _classCallCheck(this, StaticNodeView);

    return _possibleConstructorReturn(this, Object.getPrototypeOf(StaticNodeView).apply(this, arguments));
  }

  _createClass(StaticNodeView, [{
    key: 'render',
    value: function render() {
      var _props = this.props;
      var id = _props.id;
      var color = _props.color;
      var width = _props.width;
      var height = _props.height;
      var caption = _props.caption;


      var rectWidth = width;
      var rectHeight = height;

      var halfRectWidth = rectWidth / 2;
      var halfRectHeight = rectHeight / 2;

      var isLight = isBright(color);

      return _react2.default.createElement(
        'g',
        { transform: 'translate(' + -halfRectWidth + ', ' + -halfRectHeight + ')' },
        _react2.default.createElement('rect', {
          key: 'node-' + id,
          width: rectWidth, height: rectHeight,
          x: 0, y: 0,
          rx: _constants.NODE_BORDER_RADIUS,
          ry: _constants.NODE_BORDER_RADIUS,

          fill: color
        }),
        _react2.default.createElement(
          'g',
          { transform: 'translate(' + _constants.NODE_PADDING_HORIZONTAL + ', 8)' },
          _react2.default.createElement(_MultilineText2.default, {
            text: caption,
            maxWidth: _constants.NODE_MAX_WIDTH,
            color: isLight ? 'black' : 'white'
          })
        )
      );
    }
  }]);

  return StaticNodeView;
}(_react.Component);

exports.default = StaticNodeView;


StaticNodeView.propTypes = {
  id: _react.PropTypes.string.isRequired,
  color: _react.PropTypes.string.isRequired,
  caption: _react.PropTypes.string.isRequired,
  width: _react.PropTypes.number.isRequired,
  height: _react.PropTypes.number.isRequired
};


//////////////////
// WEBPACK FOOTER
// ./app/components/Projects/StaticProjectView/StaticNodeView.js
// module id = 609
// module chunks = 1